<span fxLayout="column" fxLayoutAlign="start center" class="w-100" fxLayoutGap="15px" *ngIf="details?.genre">
  <span fxLayout="row" fxLayoutGap="36px" class="w-100">
    
    <div fxFlex="24px"><mat-icon class="fs24">videocam</mat-icon></div>
    <span class="mb1 bb-1-grey w-100 pb12px">{{details?.genre}}
    

  </span>
</span>


<span fxLayout="row" fxLayoutGap="36px" *ngIf="details?.runtime" class="w-100">
  <div fxFlex="24px">
    <mat-icon class="fs24">schedule</mat-icon>
  </div>
  <span class="mb1 bb-1-grey w-100 pb12px">{{getRuntime()}} {{'postfix.minutes' | translate}}
  </span>
</span>

<span fxLayout="row" fxLayoutGap="36px" *ngIf="details" class="w-100">
    <div fxFlex="24px">
      <mat-icon class="fs24">tv</mat-icon>
    </div>
    <span *ngIf="(chips == null || chips?.length === 0) && !hasKino()" class="mb1 pb12px mb-1">{{'besprechung.noChannel'
      | translate}}</span>
    <span fxLayout="column">
    <span *ngIf="hasKino()" class="mb1 pb12px mb-1">{{'besprechung.inKino' | translate}}</span>
        <span fxLayout="row wrap" fxLayoutGap="5px" *ngIf="chips?.length > 0">
          <mat-basic-chip [disableRipple]="true" *ngFor="let c of chips" class="f-chip chip mb-1 outline-none clickable"
            (click)="handleChipClick(c.src, c.srcName)">
            {{ c.srcName }}

           </mat-basic-chip>
        </span>
      </span>
    </span>
</span>
